/*
 * File: d:\projects\AutoFiFront\src\Theme\ProgressBarCustom.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Tuesday March 14th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday March 14th 2023 2:29:40 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import styled from "styled-components";

const ProgressBarCustom = styled.span.attrs(props => ({
    barColor: props.barColor,
    bgColor: props.bgColor
}))`
.MuiMobileStepper,
.MuiPaper-root {
    background-color: ${props => props.bgColor} !important;
    background: ${props => props.bgColor} !important;
    border-radius: 5px;
}
.MuiLinearProgress-root{
    width: 100% !important;
    background-color: ${props => props.barColor == "CITYCAR" ? props.theme.colors.second20 : props.barColor == "SUV" ? props.theme.colors.third20 : props.barColor == "UTILITY" ? props.theme.colors.fourth20 : props.barColor == "SEDAN" ? props.theme.colors.fifth20 : props.barColor == "BREAK" ? props.theme.colors.sixth20 : props.theme.colors.first20} !important;
}

.MuiLinearProgress-bar{
    background-color: ${props => props.barColor == "CITYCAR" ? props.theme.colors.second : props.barColor == "SUV" ? props.theme.colors.third : props.barColor == "UTILITY" ? props.theme.colors.fourth : props.barColor == "SEDAN" ? props.theme.colors.fifth : props.barColor == "BREAK" ? props.theme.colors.sixth : props.theme.colors.first} !important;
}
`;

export default ProgressBarCustom;
